import React from 'react';
import siteConfig from '../config/site.json';

const Footer: React.FC = () => {
  const { site, navigation } = siteConfig;

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLegalClick = (type: string) => {
    // In a real application, these would navigate to actual legal pages
    console.log(`Navigate to ${type} page`);
    // For now, just show an alert
    alert(`${type} page - This would typically navigate to a legal document.`);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <h3>{site.name}</h3>
              <p>{site.description}</p>
            </div>
            <div className="footer-social">
              <a href={site.social.facebook} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook"></i>
              </a>
              {/* <a href={site.social.twitter} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-twitter"></i>
              </a> */}
              <a href={site.social.linkedin} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href={site.social.instagram} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href={site.social.youtube} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              {navigation.links.map((link) => (
                <li key={link.section}>
                  <button
                    className="footer-link"
                    onClick={() => scrollToSection(link.section)}
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="footer-contact">
              <p>
                <i className="fas fa-phone"></i>
                {site.contact.phone}
              </p>
              <p>
                <i className="fas fa-envelope"></i>
                {site.contact.email}
              </p>
              <p>
                <i className="fab fa-whatsapp"></i>
                {site.contact.whatsapp}
              </p>
              <p>
                <i className="fas fa-map-marker-alt"></i>
                {site.contact.address}
              </p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Business Hours</h4>
            <div className="footer-hours">
              <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
              <p>Saturday: 9:00 AM - 2:00 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 {site.name}. All rights reserved.</p>
            <div className="footer-bottom-links">
              <button 
                className="footer-legal-link"
                onClick={() => handleLegalClick('Privacy Policy')}
              >
                Privacy Policy
              </button>
              <button 
                className="footer-legal-link"
                onClick={() => handleLegalClick('Terms of Service')}
              >
                Terms of Service
              </button>
              <button 
                className="footer-legal-link"
                onClick={() => scrollToSection('contact')}
              >
                Support
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 